import _ from "lodash";

//Registration Request
export const registrationReqLoading = (registration) =>
  _.get(registration, ["registrationReq", "loading"], false);
export const registrationReqData = (registration) =>
  _.get(registration, ["registrationReq", "items"], null);
export const registrationReqStatus = (registration) =>
  _.get(registration, ["registrationReq", "status"], false);
export const registrationGetMobileNumber = (item) =>
  _.get(item, ["Mobile_Number"], null);
export const registrationStatusCode = (item) => _.get(item, ["Status"], null);
export const registrationReference_Number = (item) =>
  _.get(item, ["Reference_Number"], null);

//Registration OTP Request
export const registrationOTPReqLoading = (registration) =>
  _.get(registration, ["registrationOtp", "loading"], false);
export const registrationOTPReqData = (registration) =>
  _.get(registration, ["registrationOtp", "items"], null);
export const registrationOTPReqStatus = (registration) =>
  _.get(registration, ["registrationOtp", "status"], false);
export const registrationOtpReference = (item) =>
  _.get(item, ["OtpReference"], null);

//Registration OTP Verify
export const registrationOTPVerifyLoading = (registration) =>
  _.get(registration, ["registrationOtpVerify", "loading"], false);
export const registrationOTPVerifyData = (registration) =>
  _.get(registration, ["registrationOtpVerify", "items"], null);
export const registrationOTPVerifyStatus = (registration) =>
  _.get(registration, ["registrationOtpVerify", "status"], false);
export const registrationOTPVerifyDataData = (item) =>
  _.get(item, ["Data"], null);
export const registrationOTPVerifyDataSuccess = (item) =>
  _.get(item, ["Success"], null);
export const registrationOTPVerifyDOB = (item) =>
  _.get(item, ["DateOfBirth"], null);
export const registrationOTPVerifyEmail = (item) =>
  _.get(item, ["Email"], null);
export const registrationOTPVerifyToken = (item) =>
  _.get(item, ["Token"], null);
export const registrationOTPVerifySessionId = (item) =>
  _.get(item, ["SessionId"], null);
export const registrationOTPVerifyName = (item) => _.get(item, ["Name"], null);
export const registrationOTPVerifyIsEditable = (item) =>
  _.get(item, ["ShowFieldNameAndDOB"], null);
export const registrationOTPVerifyMessage = (item) =>
  _.get(item, ["Message"], null);
export const registrationOTPVerifyExpiryWarning = (item) =>
  _.get(item, ["SessionExpiryWarning"], null);
export const registrationOTPVerifyExpiryEnd = (item) =>
  _.get(item, ["SessionExpiryEnd"], null);
export const registrationOTPVerifyDirectClient = (item) =>
  _.get(item, ["DirectClient"], null);

//Activation Generic Link Req
export const activationGenericLinkReqLoading = (registration) =>
  _.get(registration, ["activationGenericLinkReq", "loading"], false);
export const activationGenericLinkReqData = (registration) =>
  _.get(registration, ["activationGenericLinkReq", "items"], null);
export const activationGenericLinkReqStatus = (registration) =>
  _.get(registration, ["activationGenericLinkReq", "status"], false);

//Activation Generic Link Otp Verify
export const activationGenericOtpVerifyLoading = (registration) =>
  _.get(registration, ["activationGenericOTP", "loading"], false);
export const activationGenericOtpVerifyData = (registration) =>
  _.get(registration, ["activationGenericOTP", "items"], null);
export const activationGenericOtpVerifyStatus = (registration) =>
  _.get(registration, ["activationGenericOTP", "status"], false);
export const activationOtpReference = (item) =>
  _.get(item, ["OTPReferenceNo"], null);

//Activation Personal Link Req
export const activationPersonalLinkReqLoading = (registration) =>
  _.get(registration, ["activationPersonalLinkReq", "loading"], false);
export const activationPersonalLinkReqData = (registration) =>
  _.get(registration, ["activationPersonalLinkReq", "items"], null);
export const activationPersonalLinkReqStatus = (registration) =>
  _.get(registration, ["activationPersonalLinkReq", "status"], false);
export const activationPersonalLinkErrorMsg = (item) =>
  _.get(item, ["Error_Message"], null);
export const activationPersonalLinkIsActivated = (item) =>
  _.get(item, ["Is_Activated"], null);
export const activationPersonalLinkIsSuccess = (item) =>
  _.get(item, ["Is_Success"], null);

//Activate Personal Req
export const activatePersonalReqLoading = (registration) =>
  _.get(registration, ["activationPersonalLinkReq", "loading"], false);
export const activatePersonalReqData = (registration) =>
  _.get(registration, ["activationPersonalLinkReq", "items"], null);
export const activatePersonalReqStatus = (registration) =>
  _.get(registration, ["activationPersonalLinkReq", "status"], false);
export const activatePersonalErrorMsg = (item) =>
  _.get(item, ["Error_Message"], null);
export const activatePersonalMobileNo = (item) =>
  _.get(item, ["Mobile_No"], null);
export const activatePersonalOTPReferenceNo = (item) =>
  _.get(item, ["OTPReferenceNo"], null);
export const activatePersonalIsActivated = (item) =>
  _.get(item, ["Is_Activated"], null);
export const activatePersonalIsSuccess = (item) =>
  _.get(item, ["Is_Success"], null);

//Prompt Mobile Phone Input
export const promptMobilePhoneInputLoading = (registration) =>
  _.get(registration, ["promptMobilePhoneInput", "loading"], false);
export const promptMobilePhoneInputData = (registration) =>
  _.get(registration, ["promptMobilePhoneInput", "items"], null);
export const promptMobilePhoneInputStatus = (registration) =>
  _.get(registration, ["promptMobilePhoneInput", "status"], false);
export const promptMobilePhoneInputDataOtpReference = (item) =>
  _.get(item, ["Data"], null);
export const promptMobilePhoneInputDataMsg = (item) =>
  _.get(item, ["Message"], null);

//Update Client Info
export const updateClientInfoLoading = (registration) =>
  _.get(registration, ["updateClientInfo", "loading"], false);
export const updateClientInfoData = (registration) =>
  _.get(registration, ["updateClientInfo", "items"], null);
export const updateClientInfoStatus = (registration) =>
  _.get(registration, ["updateClientInfo", "status"], false);

//Registration Resend OTP
export const registrationOtpResendLoading = (registration) =>
  _.get(registration, ["registrationOTPResend", "loading"], false);
export const registrationOtpResendData = (registration) =>
  _.get(registration, ["registrationOTPResend", "items"], null);
export const registrationOtpResendStatus = (registration) =>
  _.get(registration, ["registrationOTPResend", "status"], false);
export const registrationOtpResendDataData = (item) =>
  _.get(item, ["Data"], null);

//Validate Movie Reg
export const validateMovieRegLoading = (registration) =>
  _.get(registration, ["validateMovieReg", "loading"], false);
export const validateMovieRegData = (registration) =>
  _.get(registration, ["validateMovieReg", "items"], null);
export const validateMovieRegStatus = (registration) =>
  _.get(registration, ["validateMovieReg", "status"], false);
  export const validateMovieRegDataData = (item) =>
  _.get(item, ["Data"], null);
  export const validateMovieRegDataStatus = (item) =>
  _.get(item, ["Status"], null);
  export const validateMovieRegDataMessage = (item) =>
  _.get(item, ["Message"], null);
  export const validateMovieRegDataOtpReference = (item) =>
  _.get(item, ["OtpReference"], null);
  

//Submit Movie Reg
export const submitMovieRegLoading = (registration) =>
  _.get(registration, ["submitMovieReg", "loading"], false);
export const submitMovieRegData = (registration) =>
  _.get(registration, ["submitMovieReg", "items"], null);
export const submitMovieRegStatus = (registration) =>
  _.get(registration, ["submitMovieReg", "status"], false);
  export const submitMovieRegDataData = (item) =>
  _.get(item, ["Data"], null);
  export const submitMovieRegDataStatus = (item) =>
  _.get(item, ["Status"], null);
  export const submitMovieRegDataMessage = (item) =>
  _.get(item, ["Message"], null);

//submitCampaignFormReq
export const submitCampaignFormReqLoading = (registration) =>
_.get(registration, ["submitCampaignFormReq", "loading"], false);
export const submitCampaignFormReqStatus = (registration) =>
_.get(registration, ["submitCampaignFormReq", "status"], false);
export const submitCampaignFormReqData = (registration) =>
_.get(registration, ["submitCampaignFormReq", "items"], null);
export const submitCampaignFormReqDataData = (item) =>
_.get(item, ["Data"], null);
export const submitCampaignFormReqDataStatus = (item) =>
_.get(item, ["Status"], null);
export const submitCampaignFormReqDataMessage = (item) =>
_.get(item, ["Message"], null);

//calculateWalkWagAmountReq
export const calculateWalkWagAmountReqLoading = (registration) =>
_.get(registration, ["calculateWalkWagAmountReq", "loading"], false);
export const calculateWalkWagAmountReqStatus = (registration) =>
_.get(registration, ["calculateWalkWagAmountReq", "status"], false);
export const calculateWalkWagAmountReqData = (registration) =>
_.get(registration, ["calculateWalkWagAmountReq", "items"], null);
export const calculateWalkWagAmountReqDataData = (item) =>
_.get(item, ["Data"], null);
export const calculateWalkWagAmountReqDataStatus = (item) =>
_.get(item, ["Status"], null);
export const calculateWalkWagAmountReqDataMessage = (item) =>
_.get(item, ["Message"], null);
export const calculateWalkWagAmountReqDataCategory1Count = (item) =>
_.get(item, ["Category1Count"], null);
export const calculateWalkWagAmountReqDataCategory2Count = (item) =>
_.get(item, ["Category2Count"], null);
export const calculateWalkWagAmountReqDataCategory3Count = (item) =>
_.get(item, ["Category3Count"], null);
export const calculateWalkWagAmountReqDataCategory1Amount = (item) =>
_.get(item, ["Category1Amount"], null);
export const calculateWalkWagAmountReqDataCategory2Amount = (item) =>
_.get(item, ["Category2Amount"], null);
export const calculateWalkWagAmountReqDataCategory3Amount = (item) =>
_.get(item, ["Category3Amount"], null);
export const calculateWalkWagAmountReqDataTotalAmount = (item) =>
_.get(item, ["TotalAmount"], null);
export const calculateWalkWagAmountReqDataQRData = (item) =>
_.get(item, ["QRData"], null);
export const calculateWalkWagAmountReqDataQRReference = (item) =>
_.get(item, ["QRReference"], null);
export const calculateWalkWagAmountReqDataCalculateMessage = (item) =>
_.get(item, ["Message"], null);
export const calculateWalkWagAmountReqDataSavedAmount = (item) =>
_.get(item, ["SavedAmount"], null);

//checkPayNowQRStatusReq
export const checkPayNowQRStatusReqLoading = (registration) =>
_.get(registration, ["checkPayNowQRStatusReq", "loading"], false);
export const checkPayNowQRStatusReqStatus = (registration) =>
_.get(registration, ["checkPayNowQRStatusReq", "status"], false);
export const checkPayNowQRStatusReqData = (registration) =>
_.get(registration, ["checkPayNowQRStatusReq", "items"], null);
export const checkPayNowQRStatusReqDataData = (item) =>
_.get(item, ["Data"], null);
export const checkPayNowQRStatusReqDataStatus = (item) =>
_.get(item, ["Status"], null);
export const checkPayNowQRStatusReqDataSuccesMessage = (item) =>
_.get(item, ["SuccesMessage"], null);
export const checkPayNowQRStatusReqDataErrorMessage = (item) =>
_.get(item, ["ErrorMessage"], null);
export const checkPayNowQRStatusReqDataErrorCode = (item) =>
_.get(item, ["ErrorCode"], null);

export const getRegistrationCustomerDetailsLoading = (registration) =>
  _.get(registration, ["getRegistrationCustomerDetails", "loading"], false);
export const getRegistrationCustomerDetailsData = (registration) =>
  _.get(registration, ["getRegistrationCustomerDetails", "items"], null);
export const getRegistrationCustomerDetailsStatus = (registration) =>
  _.get(registration, ["getRegistrationCustomerDetails", "status"], false);

  export const registerNewCustomerLoading = (registration) =>
  _.get(registration, ["registerNewCustomer", "loading"], false);
export const registerNewCustomerData = (registration) =>
  _.get(registration, ["registerNewCustomer", "items"], null);
export const registerNewCustomerStatus = (registration) =>
  _.get(registration, ["registerNewCustomer", "status"], false);

  //revamp 2.0
  export const getRegistrationCustomerInfoLoading = (registration) =>
  _.get(registration, ["getRegistrationCustomerInfo", "loading"], false);
export const getRegistrationCustomerInfoData = (registration) =>
  _.get(registration, ["getRegistrationCustomerInfo", "items"], null);
export const getRegistrationCustomerInfoStatus = (registration) =>
  _.get(registration, ["getRegistrationCustomerInfo", "status"], false);

  export const getLoginTokenLoading = (registration) =>
  _.get(registration, ["getLoginToken", "loading"], false);
export const getLoginTokenData = (registration) =>
  _.get(registration, ["getLoginToken", "items"], null);
export const getLoginTokenStatus = (registration) =>
  _.get(registration, ["getLoginToken", "status"], false);

  export const generateOTPOnboardingLoading = (registration) =>
  _.get(registration, ["generateOTPOnboarding", "loading"], false);
export const generateOTPOnboardingData = (registration) =>
  _.get(registration, ["generateOTPOnboarding", "items"], null);
export const generateOTPOnboardingStatus = (registration) =>
  _.get(registration, ["generateOTPOnboarding", "status"], false);

  export const registerNewCustomerv2Loading = (registration) =>
  _.get(registration, ["registerNewCustomerV2", "loading"], false);
export const registerNewCustomerv2Data = (registration) =>
  _.get(registration, ["registerNewCustomerV2", "items"], null);
export const registerNewCustomerv2Status = (registration) =>
  _.get(registration, ["registerNewCustomerV2", "status"], false);

  export const logRegistrationRequestLoading = (registration) =>
  _.get(registration, ["logRegistrationReq", "loading"], false);
export const logRegistrationRequestData = (registration) =>
  _.get(registration, ["logRegistrationReq", "items"], null);
export const logRegistrationRequestStatus = (registration) =>
  _.get(registration, ["logRegistrationReq", "status"], false);

  export const validateRegistrationLoading = (registration) =>
  _.get(registration, ["validationReg", "loading"], false);
export const validateRegistrationData = (registration) =>
  _.get(registration, ["validationReg", "items"], null);
export const validateRegistrationStatus = (registration) =>
  _.get(registration, ["validationReg", "status"], false);

  export const uploadOcrNricLoading = (registration) =>
  _.get(registration, ["uploadOCRNRIC", "loading"], false);
export const uploadOcrNricData = (registration) =>
  _.get(registration, ["uploadOCRNRIC", "items"], null);
export const uploadOcrNrictStatus = (registration) =>
  _.get(registration, ["uploadOCRNRIC", "status"], false);

  export const updateClientInfov4RequestLoading = (registration) =>
  _.get(registration, ["updateClientInfoV4", "loading"], false);
export const updateClientInfov4RequestData = (registration) =>
  _.get(registration, ["updateClientInfoV4", "items"], null);
export const updateClientInfov4RequestStatus = (registration) =>
  _.get(registration, ["updateClientInfoV4", "status"], false);
